import React, { useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import Hero from '../components/landing/Hero';
import ProblemSolution from '../components/landing/ProblemSolution';
import Features from '../components/landing/Features';
import Demo from '../components/landing/Demo';
import ROI from '../components/landing/ROI';
import Testimonials from '../components/landing/Testimonials';
import Pricing from '../components/landing/Pricing';
import CTA from '../components/landing/CTA';
import Footer from '../components/landing/Footer';
import { Sparkles } from 'lucide-react';

export default function LandingPage() {
  const { isDark } = useTheme();

  useEffect(() => {
    // Smooth scroll pour les ancres
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        if (href && href !== '#') {
          document.querySelector(href)?.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });
  }, []);

  return (
    <div className={`min-h-screen ${isDark ? 'bg-gray-950' : 'bg-white'}`}>
      {/* Navigation simple pour la landing */}
      <nav className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b ${
        isDark ? 'bg-gray-950/80 border-gray-800' : 'bg-white/80 border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary-500 to-purple-600 flex items-center justify-center">
                <Sparkles className="w-4 h-4 text-white" />
              </div>
              <span className={`text-xl font-bold ${
                isDark ? 'text-white' : 'text-gray-900'
              }`}>
                Insight360
              </span>
            </div>
            <div className="hidden md:flex items-center gap-8">
              <a href="#features" className={`text-sm ${
                isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}>Fonctionnalités</a>
              <a href="#pricing" className={`text-sm ${
                isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}>Tarifs</a>
              <a href="#demo" className={`text-sm ${
                isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}>Démo</a>
            </div>
            <div className="flex items-center gap-4">
              <a href="/login" className={`text-sm font-medium ${
                isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'
              }`}>
                Se connecter
              </a>
              <button className="px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-xl hover:bg-primary-700 transition-all shadow-lg shadow-primary-500/20">
                Demander une démo
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Contenu principal avec padding top pour la navbar fixe */}
      <main className="pt-16">
        <Hero />
        <ProblemSolution />
        <Features />
        <Demo />
        <ROI />
        <Testimonials />
        <Pricing />
        <CTA />
        <Footer />
      </main>
    </div>
  );
}